import { z } from 'zod'

import { nonEmptyArraySchema } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  EmailAddressSchema,
  OptionalNonEmptyStringSchema,
  PhoneNumberSchema,
  UrlSchema,
} from './property.models.ts'
import { TeamIdSchema, TeamProfileIdSchema } from './unique-id.models.ts'

/**
 * TeamProfileDomainSelectModel
 */
export const TeamProfileDomainSelectModelSchema = z.object({
  teamProfileId: TeamProfileIdSchema,
  teamId: TeamIdSchema,
  overview: OptionalNonEmptyStringSchema(4096),
  emailAddresses: nonEmptyArraySchema(EmailAddressSchema),
  websiteUrls: nonEmptyArraySchema(UrlSchema).optional(),
  phoneNumbers: nonEmptyArraySchema(PhoneNumberSchema).optional(),
})

export type TeamProfileDomainSelectModel = ZodInfer<
  typeof TeamProfileDomainSelectModelSchema
>

/**
 * TeamProfileDomainInsertModel
 */
export const TeamProfileDomainInsertModelSchema =
  TeamProfileDomainSelectModelSchema.partial({
    teamProfileId: true,
  })

export type TeamProfileDomainInsertModel = ZodInfer<
  typeof TeamProfileDomainInsertModelSchema
>

/**
 * TeamProfileDomainUpsertModel
 */
export const TeamProfileDomainUpsertModelSchema =
  TeamProfileDomainInsertModelSchema.omit({
    teamProfileId: true,
    teamId: true,
  })

export type TeamProfileDomainUpsertModel = ZodInfer<
  typeof TeamProfileDomainUpsertModelSchema
>

/**
 * TeamProfileDomainUpdateModel
 */
export const TeamProfileDomainUpdateModelSchema =
  TeamProfileDomainUpsertModelSchema.partial()

export type TeamProfileDomainUpdateModel = ZodInfer<
  typeof TeamProfileDomainUpdateModelSchema
>

/**
 * TeamProfileDomainSelectModelFiltersSchema
 */
export const TeamProfileDomainSelectModelFiltersSchema = z
  .object({
    teamProfileId: ModelFilterSchema(TeamProfileIdSchema),
    teamId: ModelFilterSchema(TeamIdSchema),
  })
  .partial()

export type TeamProfileDomainSelectModelFilters = ZodInfer<
  typeof TeamProfileDomainSelectModelFiltersSchema
>
